import { render, staticRenderFns } from "./EventSchedule.vue?vue&type=template&id=70e7c9fa"
import script from "./EventSchedule.vue?vue&type=script&lang=js"
export * from "./EventSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports